import React from "react";

const BayanTableComponentLoadable = React.lazy(() =>
  import("./BayanTableComponent")
);

export { BayanTableComponentLoadable };
